<template>
  <div class="cplan-unit-card-outer">
    <div class="cplan-unit-card">
      <div :class="['cplan-unit-card__type-label', labelClass]">{{unit.firstLevelTitle}}</div>
      <div class="cplan-unit-card__top">
        <div class="cplan-unit-card__head">
          <div class="cplan-unit-card__code">{{ unit.relationship.code }}</div>
          <div class="cplan-unit-card__credits">{{ unit.relationship.credits }} credit points</div>
        </div>
        <div class="cplan-unit-card__title">
          <button type="button" class="btn-link-bold" v-on:click="clickUnitTitle">{{unit.relationship.name}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SlideOutUnitDetailsView from '../select-units/slide-out-tree-view/SlideOutUnitDetailsView.vue'

export default {
  props: {
    unit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView
    }
  },
  computed: {
    labelClass() {
      return `unit-${this.unit.firstLevelTitle.toLowerCase().replace(/\s/gi, '-')}`
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    }),
    clickUnitTitle() {
      this.unit.canComplete = false
      this.openSlideOut({ component: this.slideOutComponent, componentProperties: this.unit })
    }
  },
  components: {}
}
</script>
